export default "__VITE_ASSET__CpP58q8k__"